import { useEffect, useState } from 'react';

const Plans = () => {
    const [imagenes, setImagenes] = useState({});

    useEffect(() => {
        fetch("https://musashijj.cl/login/admin/landing/api/getPlanes.php")
            .then((res) => res.json())
            .then((data) => {
                const imagenesPorNombre = {};
                data.planes.forEach(plan => {
                    const filename = plan.pathname.split('/').pop();
                    const name = filename.split('.')[0].toUpperCase();
                    imagenesPorNombre[name] = plan.pathname;
                });
                setImagenes(imagenesPorNombre);
            })
            .catch((err) => {
                console.error("Error cargando las imágenes de planes:", err);
            });
    }, []);

    return (
        <>
            <h2 className="h2-title">
                PLANES DE ENTRENAMIENTO
            </h2>
            <div className="planes">
                {["MUSASHI", "INFANTIL", "JUVENIL"].map(plan => (
                    <div className="plan-card" key={plan}>
                        <a href="#contacto" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <img
                                src={imagenes[plan] || ""}
                                alt={plan}
                                className="plan-card-image"
                                decoding="async"
                                loading="lazy"
                            />
                            <h3 className={`h3-title ${plan}`}>{plan === "ALLIANCE" ? "MUSASHI" : plan}</h3>
                            <p className="plan-card-text">
                                {plan === "MUSASHI" && "Podrás entrenar sin límites y ser parte de una comunidad que te impulsa a dar siempre un paso más. Accede a todas las clases, mejora tu nivel y aprovecha al máximo cada entrenamiento."}
                                {plan === "INFANTIL" && "Un espacio pensado para que los más pequeños aprendan, se diviertan y desarrollen confianza desde el primer día.  Clases dinámicas, profesores comprometidos y una base sólida para su crecimiento."}
                                {plan === "JUVENIL" && "Entrenamientos diseñados para potenciar disciplina, carácter y confianza en cada etapa.  Un lugar donde los jóvenes crecen, se desafían y evolucionan junto a un equipo que los impulsa."}
                            </p>
                        </a>
                    </div>
                ))}
            </div>

            <a className="plan-button" target="_blank" rel="noopener noreferrer" href="https://musashijj.cl/login/planes">
                CONSULTAR PLANES
            </a>
        </>
    );
};

export default Plans;
